import { Fade } from "@ui/components/feedback/fade/Fade";
import { Box } from "@ui/components/layout/box/Box";
import { Flex } from "@ui/components/layout/flex/Flex";
import type { Header } from "../../types";
import { styles } from "./Success.style";

type Props = {
    headers: Header;
};

export const Success = ({ headers }: Props) => {
    const { descriptionSuccess, header, headerSuccess } = headers;
    return (
        <Flex {...styles.wrapper}>
            <Box {...styles.headerBox} data-testid="subscription-footer-header">
                <Fade in key="header">
                    <Box {...styles.headerFadeBox}>{header}</Box>
                </Fade>
            </Box>
            <Box {...styles.headerSuccessBox}>
                <Fade in key="header-success">
                    <Box {...styles.headerSuccessFadeBox}>{headerSuccess}</Box>
                </Fade>
            </Box>
            <Box {...styles.descriptionSuccessBox}>
                <Fade in key="description-success">
                    <Box {...styles.descriptionSuccessFadeBox}>{descriptionSuccess}</Box>
                </Fade>
            </Box>
        </Flex>
    );
};
